<div id="openExtendsSelectCollaborators" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title f-s-14 m-0">Seleccionar Colaborador</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>     
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-12">
                  <label>Colaborador<span class="required"></span>
                    <div class="book__nrodoc m-l-20" *ngIf="isCollaboratorSelected">
                      ({{collaboratorSelected.partnercompany}})
                    </div>
                  </label>
                  <ng-container *ngIf="isCollaboratorSelected">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="N° DOC: {{collaboratorSelected.document}} - {{collaboratorSelected.fullname}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          (click)="removeCollaborator()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!isCollaboratorSelected">
                    <div class="input-group input-group-grid">
                      <component-search-collaborators [classSize]="'search-small'"
                        (selectedCollaboratorsEvent)="selectedCollaboratorsSearch($event)" class="w-100">
                      </component-search-collaborators>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
            (click)="close()">Cancelar</button>
          <button (click)="onSubmit()" class="btn btn-primary" [disabled]="!isCollaboratorSelected">Asignar Colaborador</button>
        </div>
    </div>
  </div>
</div>
